<template>
    <div class="ur-tab__content" :class="contentClass">
        <!--
            $ver: v0.1.0
            content영역을 채우는 default slot입니다.
            #The default slot that fills the content area.
        -->
        <slot/>
    </div>
</template>

<script>
// ur-tab-content는label영역 클릭시에 표시되는 내용입니다
// #ur-tab-content is the content displayed when the label area is clicked
export default {
    name:'urTabContent',
    inject:['tabBox'],
    props:{
        // $ver: v0.1.0
        // 탭 컨텐츠의 index입니다.
        // 라벨영역 클릭시에 표시되는 컨텐츠의 키 역할을 합니다.
        // #This is index of tab contents.
        // #This index is key for content to show when clicking the same key label.
        // $default: false
        // $tags IDE, idx
        idx:[String,Number],
        // $ver: v0.1.0
        // 탭 컨텐츠의 라벨입니다.
        // 이 옵션을 활성화 한경우 tab-label 컴포넌트를 생략할 수 있습니다.
        // #This is label of tab contents.
        // #'Tab-label' component can be skiped when this option is active.
        // $default: ''
        label:String
    },
    computed: {
        currIdx()  { return this.tabBox.currIdx },
        isActive() { return this.idx === this.currIdx },
        contentClass() {
            return {"ur-tab__content--active":this.isActive};
        }
    }
}
</script>
